import * as React from 'react'

import { Link as RouterLink } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { FLOWS } from '../../../app/AppRouter'
import { FlowName } from '../../../@types/flow-types'

/**
 * Only used in local setup to show a list of all available flows.
 */
const FlowChooserPage: React.FC = () => {
  const publishedListingApartmentRentUuid = React.useMemo(() => uuid(), [])
  const agentPublishedListingApartmentRentUuid = React.useMemo(() => uuid(), [])
  const publishedListingHouseSellUuid = React.useMemo(() => uuid(), [])

  return (
    <div className='padding-xl'>
      <h3>Flow Chooser Page MOCK</h3>

      <div className='grid grid-flex gutter-m'>
        {FLOWS.map((flow, index) => (
          <div className='grid-item one-whole' key={index}>
            <RouterLink to={flow.flowInformation.path} className='button-primary'>
              {flow.flowInformation.name.replaceAll('_', ' ').toUpperCase()}
            </RouterLink>
            <RouterLink to={`${flow.flowInformation.path}?isVermietetDeView=true`} className='button-secondary'>
              {'isVermietetDeView'}
            </RouterLink>
            <RouterLink to={`${flow.flowInformation.path}?isMobileView=true`} className='button-secondary'>
              {'isMobileView'}
            </RouterLink>
            {flow.flowInformation.name === FlowName.PROPERTY_OWNER_APARTMENT_RENT && (
              <RouterLink
                to={`${flow.flowInformation.path}/published-listing-apartment-rent-${publishedListingApartmentRentUuid}`}
                className='button-secondary'
              >
                {'Published Listing'}
              </RouterLink>
            )}
            {flow.flowInformation.name === FlowName.AGENT_APARTMENT_RENT && (
              <RouterLink
                to={`${flow.flowInformation.path}/agent-published-listing-apartment-rent-${agentPublishedListingApartmentRentUuid}`}
                className='button-secondary'
              >
                {'Published Listing'}
              </RouterLink>
            )}
            {flow.flowInformation.name === FlowName.PROPERTY_OWNER_HOUSE_SELL && (
              <RouterLink
                to={`${flow.flowInformation.path}/published-listing-house-sell-${publishedListingHouseSellUuid}`}
                className='button-secondary'
              >
                {'Published Listing'}
              </RouterLink>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default FlowChooserPage
